/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StudentSurveyAnswer from './StudentSurveyAnswer';
import SurveyAnswer from './SurveyAnswer';

/**
 * The SurveyQuestion model module.
 * @module model/SurveyQuestion
 * @version 1.0.0
 */
class SurveyQuestion {
    /**
     * Constructs a new <code>SurveyQuestion</code>.
     * A question in a survey
     * @alias module:model/SurveyQuestion
     */
    constructor() { 
        
        SurveyQuestion.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SurveyQuestion</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SurveyQuestion} obj Optional instance to populate.
     * @return {module:model/SurveyQuestion} The populated <code>SurveyQuestion</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SurveyQuestion();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('question_text')) {
                obj['question_text'] = ApiClient.convertToType(data['question_text'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [SurveyAnswer]);
            }
            if (data.hasOwnProperty('student_answer')) {
                obj['student_answer'] = StudentSurveyAnswer.constructFromObject(data['student_answer']);
            }
        }
        return obj;
    }


}

/**
 * Question identifier
 * @member {Number} id
 */
SurveyQuestion.prototype['id'] = undefined;

/**
 * Question text
 * @member {String} question_text
 */
SurveyQuestion.prototype['question_text'] = undefined;

/**
 * Order of the question in the survey
 * @member {Number} order
 */
SurveyQuestion.prototype['order'] = undefined;

/**
 * List of possible answers for the question
 * @member {Array.<module:model/SurveyAnswer>} answers
 */
SurveyQuestion.prototype['answers'] = undefined;

/**
 * @member {module:model/StudentSurveyAnswer} student_answer
 */
SurveyQuestion.prototype['student_answer'] = undefined;






export default SurveyQuestion;

